import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from "shared/components/checkbox";
import $ from "jquery";
import "shared/jquery/icon";

export default class CustomDataCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.cdRef = React.createRef();
  }

  render() {
    return (
      <Checkbox
        id={"custom-data-check"}
        state={true}
        disabled={false}
        label={this.helpLabel()}
        onChange={this.toggleEnabled.bind(this)}
      />
    );
  }

  helpLabel() {
    return (
      <span data-label="custom-data-label">Move Custom Data associated with this Promo Number&nbsp;
        <i className="material-icons icon--help" ref={this.cdRef} data-label="custom-data-help">help</i>
      </span>
    );
  }

  toggleEnabled() {
    const newValue = !this.props.moveCustomData;
    this.props.toggleCustomData({ moveCustomData: newValue });
  }

  componentDidMount() {
    const helpContent = "Enable this checkbox if you would like the same attribution captured for this number when " +
      "it is being used for a different campaign";

    $(this.cdRef.current).helpPopover({
      title: "When would I want to move Custom Data?",
      content: helpContent,
      trigger: "hover"
    });
  }
}

CustomDataCheckbox.propTypes = {
  moveCustomData:   PropTypes.bool,
  toggleCustomData: PropTypes.func
};
